// frontend/src/hooks/useWebSearch.js
// frontend/src/hooks/useWebSearch.js

import axios from 'axios';

const DUCK_API_URL = 'https://www.searchapi.io/api/v1/search';
const DUCK_API_KEY = process.env.REACT_APP_SEARCHAPI_DDG_API_KEY; // 💬 You added this safely already

export async function fetchWebSearchResults(query) {
  if (!DUCK_API_KEY) {
    console.error('❌ Missing DuckDuckGo API Key!');
    return null;
  }

  try {
    const response = await axios.get(DUCK_API_URL, {
      params: {
        engine: 'duckduckgo',
        q: query,
        api_key: DUCK_API_KEY,
        safe: 'moderate',
        locale: 'us-en',
        time_period: 'past_week', // or 'any_time' depending on your preference
      },
    });

    const organicResults = response.data?.organic_results || [];

    if (organicResults.length === 0) {
      console.warn('⚠️ No useful search results found.');
      return null;
    }

    const topThreeSummaries = organicResults.slice(0, 3).map((result) => ({
      title: result.title || '',
      snippet: result.snippet || '',
      url: result.link || '',
    }));

    console.log('📡 Fetched top 3 web search results:', topThreeSummaries);

    return topThreeSummaries;

  } catch (error) {
    console.error('❌ Web search API error:', error.message);
    return null;
  }
}
